import { defaultTheme } from '../../theming/data/defaultTheme'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import styled from 'styled-components'
import { composeTheme } from '../../utils/compose-theme'

export const IconWrapper = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  top: 2.9rem;
  display: flex;
  height: 4rem;
  grid-row: 1;
  grid-column: 3;

  &.icon-position-left {
    grid-column: 1;
  }

  > * {
    padding: ${(props) => props.theme.input.iconPadding};
    color: ${(props) => props.theme.input.iconColor} !important;
  }
`

export const InputText = styled.input.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.input.color};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.input.fontSize};
  line-height: ${(props) => props.theme.input.fontHeight};
  border-radius: ${(props) => props.theme.input.borderRadius};
  border: ${(props) => props.theme.input.borderWidth} solid
    ${(props) => props.theme.input.borderColor};
  margin: ${layout.margin.spacingNone};
  background-color: ${(props) => props.theme.input.background};
  padding: ${(props) => props.theme.input.paddingTop}
    ${(props) => props.theme.input.paddingRight}
    ${(props) => props.theme.input.paddingBotton}
    ${(props) => props.theme.input.paddingLeft};

  &:focus {
    border: ${border.width.widthThin} solid
      ${(props) => props.theme.brandColors.primaryPure};
    outline: none;
  }

  &::placeholder {
    color: ${(props) => props.theme.input.placeholderColor} !important;
  }

  &:disabled {
    background-color: ${colors.neutralColorHighLight};
    color: ${colors.neutralColorLowMedium};
  }

  .icon {
    position: absolute;
  }

  &.negative {
    border-color: ${(props) => props.theme.input.negativeBorderColor};
    background-color: ${(props) => props.theme.input.negativeBackgroundColor};
  }

  &.has-prefix {
    padding-left: ${layout.padding.spacingInsetLg};
    padding-right: ${layout.padding.spacingInsetNano};
  }
`

export const Prefix = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  top: 2.8rem;
  display: flex;
  height: 4rem;
  position: absolute;
  left: 0;
  color: ${(props) => props.theme.input.prefixColor};

  > * {
    margin-left: 1.2rem;
  }
`

export const Hint = styled.p.attrs((props) => composeTheme(props))`
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${(props) => props.theme.hint.fontWeight};
  font-size: ${(props) => props.theme.hint.fontSize};
  align-items: left;
  color: ${(props) => props.theme.hint.color};
  margin-top: ${(props) => props.theme.hint.marginTop};
  margin-bottom: ${(props) => props.theme.hint.marginBottom};
  padding-top: ${(props) => props.theme.hint.paddingTop};

  &.is-negative {
    color: ${(props) => props.theme.hint.negativeColor};
  }
`
export const LabelWrapper = styled.label`
  display: grid;
  grid-template-columns: auto 1fr auto;
  margin-bottom: ${layout.margin.spacingXxs};
  input {
    grid-row: 1;
    grid-column: 1/4;
  }
`

InputText.defaultProps = defaultTheme
IconWrapper.defaultProps = defaultTheme
Prefix.defaultProps = defaultTheme
Hint.defaultProps = defaultTheme
